export default __webpack_public_path__ + "static/media/Gold1.78a52f88.svg";